var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pushSoftAskWrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "rightBox" }, [
      _c("div", { staticClass: "headerText" }, [
        _vm._v(
          "\n\t\t\t" + _vm._s(_vm.$t("webPush.softAsk.headerText")) + "\n\t\t"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subText" }, [
        _vm._v(
          "\n\t\t\t" + _vm._s(_vm.$t("webPush.softAsk.subText")) + "\n\t\t"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttonWrapper decline" }, [
        _c(
          "button",
          { staticClass: "declineButton", on: { click: _vm.decline } },
          [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.$t("webPush.softAsk.declineButton")) +
                "\n\t\t\t"
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttonWrapper accept" }, [
        _c(
          "button",
          { staticClass: "acceptButton", on: { click: _vm.accept } },
          [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.$t("webPush.softAsk.acceptButton")) +
                "\n\t\t\t"
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leftBox" }, [
      _c("div", { staticClass: "logo" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }